/**
 * NotPlacedGroup: one reason's worth of a map's not-placed list. The
 * capacity map (clients, by reason) and the resource directory's map
 * (organizations and people, by reason) both list what they cannot draw
 * in this one shape: hundreds of names at once buried the map, so the
 * reason and its count are the line and the names sit behind it.
 */

import { type ReactNode } from 'react';
import { Link } from 'react-router-dom';

export interface NotPlacedItem {
  id: string;
  label: string;
  href: string;
}

export function NotPlacedGroup({
  label,
  items,
  testId,
  itemTestId,
}: {
  label: string;
  items: NotPlacedItem[];
  testId: string;
  itemTestId: string;
}): ReactNode {
  return (
    <details className="mt-1" data-testid={testId}>
      <summary className="cursor-pointer list-none text-xs font-semibold uppercase tracking-wider text-sage-700 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sage-400 rounded-base">
        {label} ({items.length})
        <span aria-hidden="true" className="ml-1 font-normal normal-case tracking-normal text-ink-soft">
          show
        </span>
      </summary>
      <ul className="mt-1 flex flex-wrap gap-1.5">
        {items.map((n) => (
          <li key={n.id}>
            <Link
              to={n.href}
              className="text-xs text-sage-700 bg-cream rounded-pill px-2 py-0.5 no-underline hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sage-400"
              data-testid={itemTestId}
            >
              {n.label}
            </Link>
          </li>
        ))}
      </ul>
    </details>
  );
}
